import React, { useEffect, useState } from "react";
import logo from "../../assets/logo_transparent.svg";
import "./style.css";
import { Button, ConfigProvider } from "antd";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import api from "../../api";
import Swal from "sweetalert2";

const MemberInvite = () => {
  const navigate = useNavigate();
  const [host, setHost] = useState("");
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("id");

  const ReadData = async () => {
    try {
      const response = await api.get(`/auth/invite-data/${id}`);
      setHost(response?.data?.response?.host?.nameOfCoworkingSpace);
    } catch (error) {
      console.log(error);
    }
  };

  const handleResponse = async (response) => {
    let res = await api.patch(`/auth/patch-invitation/${id}`, {
      response: response,
    });
    if (res.status == 200) {
      if (res.data.status == "ok") {
        Swal.fire({
          icon: "success",
          title: "Accepted Successfully",
        }).then(() => {
          window.location.href = process.env.REACT_APP_FRONTEND_URL;
        });
      } else {
        Swal.fire({
          icon: "success",
          title: "Declined Successfully",
        }).then(() => {
          window.location.href = process.env.REACT_APP_FRONTEND_URL;
        });
      }
    }
  };

  useEffect(() => {
    if (id) {
      ReadData();
    }
  }, []);

  return (
    <>
      <div className="member-invite">
        {" "}
        <div className="card">
          <div className="text-invite">
            <img src={logo} className="logo" />
          </div>
          <div className="sucess_club">SUCCESS CLUB</div>

          {host ? (
            <>
              <div className="para">
                You're invited by {host} to join Success Club, an exclusive
                platform where like-minded individuals connect, grow, and
                achieve success!
              </div>
            </>
          ) : (
            <>
              <div className="para" style={{ color: "red" }}>
                Your invitation has been expired
              </div>
            </>
          )}

          {host && (
            <div className="buttons">
              <Button
                type="primary"
                style={{ width: "25%" }}
                onClick={() => handleResponse("accept")}
              >
                Accept
              </Button>

              <Button
                type="primary"
                style={{
                  width: "25%",
                  backgroundColor: "white",
                  borderColor: "#b17910",
                  color: "#b17910",
                }}
                onClick={() => handleResponse("decline")}
              >
                Decline
              </Button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default MemberInvite;
